export default __webpack_public_path__ + "static/media/demo.7797efac.jpg";